import type { StaffProfileStoresItem } from '@nucleus-commerce/api-client/admin';
import { Checkbox } from '@nucleus-commerce/ui/components/checkbox';
import { Label } from '@nucleus-commerce/ui/components/label';

export interface StoreChecklistProps {
  legend: string;
  stores: ReadonlyArray<Pick<StaffProfileStoresItem, 'id' | 'name'>>;
  value: readonly string[];
  onChange: (storeIds: string[]) => void;
  /** A second line under each store's name, like its timezone. */
  describe?: (storeId: string) => string | undefined;
  /** Ids prefix, so two lists on one page never share a checkbox id. */
  idPrefix?: string;
}

/** The stores a bulk action acts in, as a list of checkboxes. */
export function StoreChecklist({
  legend,
  stores,
  value,
  onChange,
  describe,
  idPrefix = 'bulk-store',
}: StoreChecklistProps) {
  return (
    <fieldset className="flex flex-col gap-2">
      <legend className="mb-1 text-sm font-medium">{legend}</legend>
      {stores.map((store) => {
        const id = `${idPrefix}-${store.id}`;
        const hint = describe?.(store.id);
        return (
          <div key={store.id} className="flex items-start gap-2">
            <Checkbox
              id={id}
              className="mt-0.5"
              checked={value.includes(store.id)}
              onCheckedChange={(checked) =>
                onChange(
                  checked === true
                    ? [...value, store.id]
                    : value.filter((storeId) => storeId !== store.id),
                )
              }
            />
            <Label htmlFor={id} className="flex flex-col items-start gap-0 font-normal">
              <span>{store.name}</span>
              {hint ? <span className="text-muted-foreground text-xs">{hint}</span> : null}
            </Label>
          </div>
        );
      })}
    </fieldset>
  );
}
